<template>
  <span class="stock-wh-wrapper">
    <span :id="triggerId" class="stock-wh-trigger"><slot /></span>
    <b-popover
      :target="triggerId"
      triggers="hover focus"
      placement="top"
      :delay="{ show: 150, hide: 50 }"
      @show="onShow"
    >
      <template slot="title">{{ title }}</template>
      <div class="stock-wh-content">
        <div v-if="loading" class="text-center text-muted">
          <i class="fa fa-spinner fa-spin"></i> Chargement…
        </div>
        <div v-else-if="error" class="text-muted">Stock indisponible</div>
        <template v-else>
          <div
            v-for="product in products"
            :key="product.id"
            class="stock-wh-product"
          >
            <div v-if="products.length > 1" class="stock-wh-product-name">
              {{ product.name }}
            </div>
            <ul class="stock-wh-list">
              <li
                v-for="row in distribution[product.id]"
                :key="row.warehouse_id || 'unassigned'"
                :class="{ 'stock-wh-unassigned': !row.warehouse_id }"
              >
                <span class="stock-wh-name">
                  {{ row.warehouse_code ? row.warehouse_code + " - " : "" }}{{ row.warehouse_name }}
                </span>
                <b-badge :variant="stockVariant(row)">{{ row.available }}</b-badge>
              </li>
              <li v-if="!distribution[product.id] || !distribution[product.id].length" class="text-muted">
                Aucun entrepôt n'a de stock
              </li>
            </ul>
          </div>
        </template>
      </div>
    </b-popover>
  </span>
</template>

<script>
// INC-001 : cache partagé entre toutes les instances (clé = product_id) pour
// éviter de rappeler l'API à chaque survol.
const distributionCache = {};

export default {
  name: "StockByWarehousePopover",
  props: {
    // Liste des produits dont on veut la ventilation : [{ id, name }]
    products: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: "Stock par entrepôt",
    },
  },
  data() {
    return {
      loading: false,
      error: false,
      distribution: {},
    };
  },
  computed: {
    triggerId() {
      return "stock-wh-pop-" + this._uid;
    },
  },
  methods: {
    // Le stock non rattaché à un entrepôt est signalé, pas présenté comme disponible :
    // il est bien physiquement là, mais on ne sait pas encore où.
    stockVariant(row) {
      if (!row.warehouse_id) {
        return "warning";
      }

      return row.available > 0 ? "success" : "secondary";
    },
    onShow() {
      // On ne charge que les produits pas encore en cache
      const toLoad = this.products
        .map((product) => product.id)
        .filter((id) => id && !(id in distributionCache));

      // On hydrate immédiatement depuis le cache
      this.hydrateFromCache();

      if (!toLoad.length) {
        return;
      }

      this.loading = true;
      this.error = false;
      Promise.all(
        toLoad.map((id) =>
          this.$http
            .get(process.env.BACK_API_URL + "product/" + id + "/stocks/by-warehouse")
            .then((response) => {
              distributionCache[id] = response.data.distribution || [];
            })
            .catch(() => {
              distributionCache[id] = [];
            })
        )
      )
        .then(() => {
          this.hydrateFromCache();
          this.loading = false;
        })
        .catch(() => {
          this.error = true;
          this.loading = false;
        });
    },
    hydrateFromCache() {
      const distribution = {};
      this.products.forEach((product) => {
        if (product.id in distributionCache) {
          distribution[product.id] = distributionCache[product.id];
        }
      });
      this.distribution = distribution;
    },
  },
};
</script>

<style lang="scss" scoped>
.stock-wh-trigger {
  cursor: help;
}
.stock-wh-content {
  min-width: 180px;
}
.stock-wh-product + .stock-wh-product {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
}
.stock-wh-product-name {
  font-weight: 600;
  margin-bottom: 4px;
}
.stock-wh-list {
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 2px 0;
  }
  .stock-wh-name {
    font-size: 12px;
  }
  .stock-wh-unassigned .stock-wh-name {
    font-style: italic;
    color: #9a6b00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/StockByWarehousePopover.vue